import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { ApIframeDelegate } from 'webcommon/core-ui';
import { isCodeSelectedEvent, isCodeSelectionChange, isSCEvent, isSFEvent, SaveAndCloseEvent, SessionCloseEvent } from 'webcommon/shared';

@Injectable()
export class TerminologyIframeDelegate extends ApIframeDelegate {
  async tryStartSave(): Promise<void> {
    // if it is single select, then we need to postMessages to close
    await this.tryPostMessageToFrame({
      eventName: 'save-and-close',
    } satisfies SaveAndCloseEvent);
  }

  // get a stream of events to be handled after initiating a 'save-and-close'
  afterSave$(): Observable<MessageEvent<SessionCloseEvent>> {
    return this.windowMessages$.pipe(
      filter((value): value is MessageEvent<SessionCloseEvent> => {
        if (isSFEvent(value)) {
          // save failed
          throw new Error('PFS terminology save failed');
        }
        return isSCEvent(value);
      }),
    );
  }

  // currently, this is useful to tell if a code is selected for single-select mode
  codeSelected$(): Observable<boolean> {
    return this.windowMessages$.pipe(
      filter(isCodeSelectionChange),
      map((value): boolean => {
        return isCodeSelectedEvent(value);
      }),
      startWith(false),
    );
  }
}
